/**
 * Authorised write proxy — routes writes to Phase 1 locked tables
 * through the AWS authorised-write Lambda (was: Supabase edge function).
 *
 * Migration: Step 9 — writes now land on AWS RDS, not Supabase.
 * The request/response shape is unchanged so callers don't need updating.
 *
 * Usage:
 *   await authWrite(session, 'purchase_orders', 'insert', { po_number: 'PO-123', ... });
 *   await authWrite(session, 'po_invoices', 'update', { status: 'paid' }, { column: 'id', value: invoiceId });
 *   await authWrite(session, 'forecaster_weekly_sales', 'upsert', { sku_id, week_start, units_sold }, null, 'sku_id,week_start');
 *   await authWrite(session, 'purchase_orders', 'delete', null, { column: 'id', value: poId });
 */

const FUNC_URL = import.meta.env.VITE_AWS_WRITE_URL;

if (!FUNC_URL) {
  throw new Error(
    '[authWrite] VITE_AWS_WRITE_URL is not set. ' +
    'Add it to app/.env.local for local dev, or to Netlify build env for deploys. ' +
    'See app/.env.example for format.'
  );
}

export async function authWrite(session, table, action, payload, match, onConflict) {
  const res = await fetch(FUNC_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      pin: session?.code,
      table,
      action,
      payload: payload || undefined,
      match: match || undefined,
      onConflict: onConflict || undefined,
    }),
  });

  const json = await res.json();
  if (!res.ok) {
    throw new Error(json.error || `Write failed: ${res.status}`);
  }
  return json.data;
}
